module.exports = __webpack_public_path__ + "static/digital-entrepreneur-awards-10c67a1d8e0cc137b0211945aad76cc9.png";